import * as clients from './list'

export const allClients = Object.values(clients).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
